import React from 'react'
import Quote from '../../../react4xp/components/Quote'

function QuotePart({ backgroundColor, image, text, name, position }) {
  return (
    <Quote
      bgColor={backgroundColor}
      alt={image?.alt}
      text={text}
      image={image?.link}
      name={name}
      position={position}
    />
  )
}

export default (props) => <QuotePart {...props} />
